export const metaData = {
  Thoout: [
    {
      day: "01",
      celebrations: [
        {
          title:
            "Beginning of the Blessed Coptic New Year (Feast of El-Nayrouz).",
        },
        {
          title: "Martyrdom of St. Bartholomew the Apostle.",
        },
        {
          title: "Departure of St. Avilius, the 3rd Pope of Alexandria.",
        },
      ],
    },
    {
      day: "02",
      celebrations: [
        {
          title: "Martyrdom of St. John the Baptist. ",
        },
        {
          title: "Martyrdom of St. Dasya the Soldier.",
        },
      ],
    },
    {
      day: "03",
      celebrations: [
        {
          title:
            "Assembly of the Holy Synod at Alexandria under St. Dionysius, the 14th Pope of Alexandria, in 243 AD.",
        },
        {
          title:
            "Great Earthquake in Cairo and Most of the Egyptian Cities in the year 1112 AD.",
        },
      ],
    },
    {
      day: "04",
      celebrations: [
        {
          title: "Departure of St. Verena.",
        },
        {
          title: "Departure of St. Macarius II, the 69th Pope of Alexandria",
        },
      ],
    },
    {
      day: "05",
      celebrations: [
        {
          title: "Martyrdom of St. Sophia",
        },
      ],
    },
    {
      day: "06",
      celebrations: [
        {
          title: "Departure of Isaiah, the Prophet.",
        },
        {
          title: "Martyrdom of St. Basilissa",
        },
      ],
    },
    {
      day: "07",
      celebrations: [
        {
          title: "Departure of St. Dioscorus, the 25th Pope of Alexandria.",
        },
        {
          title: "Departure of St. Severian, bishop of Gabala in Syria",
        },
        {
          title:
            "Martyrdom of St. Rebecca and her children Saints Agathon, Peter, John, Amun, & Amuna",
        },
      ],
    },
    {
      day: "08",
      celebrations: [
        {
          title: "Departure of Moses, the Prophet.",
        },
        {
          title: "Martyrdom of Zacharias, the Prophet.",
        },
        {
          title: "Martyrdom of St. Diomedes (Dimides).",
        },
      ],
    },
    {
      day: "09",
      celebrations: [
        {
          title: "Martyrdom of St. Pisora, Bishop of Masil",
        },
        {
          title: "Miracle of Colossae in Phrygia",
        },
      ],
    },
    {
      day: "10",
      celebrations: [
        {
          title: "Martyrdom of St. Matruna",
        },
        {
          title: "Commemoration of St. Basin and her Children",
        },
      ],
    },
    {
      day: "11",
      celebrations: [
        {
          title: "Martyrdom of St. Basilides (Wasilides) the Minister.",
        },
        {
          title: "Commemoration of Cornelius the Centurion.",
        },
        {
          title: "Departure of St. Theodora.",
        },
      ],
    },
    {
      day: "12",
      celebrations: [
        {
          title: "Commemoration of Michael, the Archangel.",
        },
        {
          title:
            "Assembly of the 3rd Ecumenical Council at Ephesus in the year 431 AD.",
        },
        {
          title:
            "Translocation of the relics of St. Clemus (Aklimos) & his companions",
        },
      ],
    },
    {
      day: "13",
      celebrations: [
        {
          title: "Departure of Pope Matthew II, the 90th Pope of Alexandria.",
        },
        {
          title:
            "Commemoration of the Miracle performed by St.Basil the Great,Bishop Caesarea, Cappadocia.",
        },
      ],
    },
    {
      day: "14",
      celebrations: [
        {
          title: "Departure of St. Agathon the Stylite",
        },
      ],
    },
    {
      day: "15",
      celebrations: [
        {
          title: "Translocation of the Body of St. Stephen, the Archdeacon.",
        },
        {
          title: "Commemoration of St. Leontius of Syria",
        },
      ],
    },
    {
      day: "16",
      celebrations: [
        {
          title:
            "Consecration of the Church of the Resurrection (Holy Sepulchre)",
        },
        {
          title: "Translocation of the relics of St. John Chrysostom.",
        },
        {
          title: "Departure of Hegumen Yakoub Saleeb Al-Masoodi",
        },
      ],
    },
    {
      day: "17",
      celebrations: [
        {
          title: "Appearance of the Holy Cross",
        },
        {
          title: "Departure of St. Theognosta",
        },
      ],
    },
    {
      day: "18",
      celebrations: [
        {
          title: "Second day of the Holy Cross Feast",
        },
        {
          title: "Martyrdom of St. Porphyrius (Prophorius)",
        },
        {
          title: "Martyrdom of St. Stephen the Priest & St. Niceta (Niketa)",
        },
      ],
    },
    {
      day: "19",
      celebrations: [
        {
          title: "Third day of the Holy Cross Feast",
        },
        {
          title:
            "Commemoration of St. Gregory the Illuminator, Patriarch of Armenia.",
        },
      ],
    },
    {
      day: "20",
      celebrations: [
        {
          title: "Departure of St. Athanasius II, the 28th Pope of Alexandria",
        },
        {
          title: "Departure of St. Theopista",
        },
        {
          title: "Martyrdom of St. Melitina the Virgin",
        },
      ],
    },
    {
      day: "21",
      celebrations: [
        {
          title:
            "Commemoration of the Holy Virgin St. Mary, the Mother of God (Theotokos)",
        },
        {
          title: "Martyrdom of St. Cyprian & St. Justina.",
        },
      ],
    },
    {
      day: "22",
      celebrations: [
        {
          title:
            "Martyrdom of Saints Cotylas (Kobtlas), his sister Axoua, and his friend Tatas",
        },
        {
          title:
            "Martyrdom of St. Julius of Aqfahs (El-Akfehasi), the Writer of the Biography of Martyrs",
        },
      ],
    },
    {
      day: "23",
      celebrations: [
        {
          title: "Martyrdom of St. Eunapios (Onanius) & St. Andrew",
        },
        {
          title: "Martyrdom of St. Thecla.",
        },
        {
          title:
            "Reopening of the Church of the Holy Virgin in the Haret al-Rum (Cairo).",
        },
      ],
    },
    {
      day: "24",
      celebrations: [
        {
          title: "Departure of St. Gregory the Ascetic",
        },
        {
          title: "Martyrdom of St. Quadratus, one of the Seventy Disciples.",
        },
      ],
    },
    {
      day: "25",
      celebrations: [
        {
          title: "Departure of Jonah, the Prophet.",
        },
        {
          title: "Martyrdom of St. Maurice, Commander of the Theban Legion.",
        },
      ],
    },
    {
      day: "26",
      celebrations: [
        {
          title:
            "Angel's Annunciation to Zechariah the Priest of the birth of St. John the Baptist",
        },
        {
          title: "Martyrdom of St. Eustathius and his two Sons",
        },
      ],
    },
    {
      day: "27",
      celebrations: [
        {
          title: "Martyrdom of St. Eustathius and his two Sons",
        },
      ],
    },
    {
      day: "28",
      celebrations: [
        {
          title:
            "Martyrdom of St. Apater (Abadir) and his sister Saint Herai (Eraee)",
        },
      ],
    },
    {
      day: "29",
      celebrations: [
        {
          title:
            "Martyrdom of St. Rhipsime (Arbsima) the Virgin, St. Gaiana, and her Sisters the Virgins",
        },
      ],
    },
    {
      day: "30",
      celebrations: [
        {
          title:
            "Commemoration of the Miracle that God performed for St. Athanasius the Apostolic.",
        },
      ],
    },
  ],
  Paope: [
    {
      day: "01",
      celebrations: [
        {
          title: "Martyrdom of St. Anastasia.",
        },
      ],
    },
    {
      day: "02",
      celebrations: [
        {
          title:
            "Arrival of St. Severus, Patriarch of Antioch, to the Egyptian Monasteries. ",
        },
      ],
    },
    {
      day: "03",
      celebrations: [
        {
          title: "Departure of St. Simon II, the 51st Pope of Alexandria.",
        },
        {
          title: "Martyrdom of St. John the Soldier",
        },
      ],
    },
    {
      day: "04",
      celebrations: [
        {
          title: "Martyrdom of St. Bacchus, the friend of St. Sergius.",
        },
      ],
    },
    {
      day: "05",
      celebrations: [
        {
          title: "Martyrdom of St. Paul, Patriarch of Constantinople.",
        },
      ],
    },
    {
      day: "06",
      celebrations: [
        {
          title:
            "Departure of the Hannah the Prophetess, mother of Samuel, the Prophet.",
        },
      ],
    },
    {
      day: "07",
      celebrations: [
        {
          title: "Departure of St. Paul of Tamouh.",
        },
        {
          title: "Martyrdom of St. Menas & St. Hasina",
        },
      ],
    },
    {
      day: "08",
      celebrations: [
        {
          title: "Martyrdom of St. Matra",
        },
        {
          title:
            "Martyrdom of the Sts Hor, Susanna (Tosia) and her Children, & St. Agathon the Hermit",
        },
      ],
    },
    {
      day: "09",
      celebrations: [
        {
          title: "Departure of St. Eumenius, the 7th Pope of Alexandria",
        },
        {
          title: "Eclipse of the Sun in the year 1242 AD.",
        },
        {
          title: " Commemoration of St. Simon the Bishop",
        },
      ],
    },
    {
      day: "10",
      celebrations: [
        {
          title: "Martyrdom of St. Sergius, the friend of St. Bacchus",
        },
      ],
    },
    {
      day: "11",
      celebrations: [
        {
          title: "Departure of St. James, Patriarch of Antioch",
        },
        {
          title: "Departure of St. Pelagia",
        },
      ],
    },
    {
      day: "12",
      celebrations: [
        {
          title: "Commemoration of Michael, the Archanagel",
        },
        {
          title: "Martyrdom of St. Matthew the Evangelist.",
        },
        {
          title: "Departure of St. Demetrius, the 12th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "13",
      celebrations: [
        {
          title: "Departure of St. Zacharias, the Monk",
        },
      ],
    },
    {
      day: "14",
      celebrations: [
        {
          title:
            "Departure of St. Philip of Caesarea, one of the Seven Deacons.",
        },
      ],
    },
    {
      day: "15",
      celebrations: [
        {
          title: "Martyrdom of St. Panteleimon, the Physician.",
        },
      ],
    },
    {
      day: "16",
      celebrations: [
        {
          title:
            "Commemoration of the St. Carpus, St. Apollos (Papylus), and St. Peter, disciples of St. Isaiah the Hermit",
        },
        {
          title: "Departure of St. Agathon, the 39th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "17",
      celebrations: [
        {
          title: "Departure of St. Dioscorus II, the 31st Pope of Alexandria.",
        },
      ],
    },
    {
      day: "18",
      celebrations: [
        {
          title: "Departure of St. Theophilus, the 23rd Pope of Alexandria",
        },
      ],
    },
    {
      day: "19",
      celebrations: [
        {
          title:
            "Assembly of the Council at Antioch against Paul of Samosata, in 280 AD.",
        },
        {
          title: "Martyrdom of St. Theophilus and his Wife in Fayyum",
        },
      ],
    },
    {
      day: "20",
      celebrations: [
        {
          title: "Departure of St. John Colobos (the Short) ",
        },
      ],
    },
    {
      day: "21",
      celebrations: [
        {
          title: "Departure of Joel, the Prophet.",
        },
        {
          title:
            "Commemoration of the Holy Virgin Saint Mary, the Mother of God (Theotokos).",
        },
        {
          title: "Relocation of the Body of Lazarus.",
        },
        {
          title: "Departure of St. Freig (Abba Tegi, or Anba Ruwais)",
        },
        {
          title: "Departure of Mother Irini.",
        },
      ],
    },
    {
      day: "22",
      celebrations: [
        {
          title: "Martyrdom of St. Luke the Evangelist.",
        },
      ],
    },
    {
      day: "23",
      celebrations: [
        {
          title: "Martyrdom of St. Dionysius, Bishop of Corinth.",
        },
        {
          title: "Departure of St. Joseph, the 52nd Pope of Alexandria.",
        },
      ],
    },
    {
      day: "24",
      celebrations: [
        {
          title: "Departure of St. Hilarion, the Anchorite.",
        },
        {
          title: "Martyrdom of the Sts. Paul, Longinus and Dinah (Zena)",
        },
      ],
    },
    {
      day: "25",
      celebrations: [
        {
          title: "Departure of the St. Abib & St. Apollo.",
        },
        {
          title:
            "Consecration of the Church of St. Julius of Aqfahs in Alexandria",
        },
      ],
    },
    {
      day: "26",
      celebrations: [
        {
          title: "Martyrdom of St. Simon the Apostle",
        },
        {
          title:
            "Commemoration of the Seven Martyrs on the Mount of St. Antony",
        },
      ],
    },
    {
      day: "27",
      celebrations: [
        {
          title: "Martyrdom of St. Macarius, Bishop of Edkow (Tkoou)",
        },
      ],
    },
    {
      day: "28",
      celebrations: [
        {
          title: "Martyrdom of the St. Marcian (Marcianus) & St. Mercurius",
        },
      ],
    },
    {
      day: "29",
      celebrations: [
        {
          title: "Martyrdom of St. Demetrius of Thessaloniki.",
        },
      ],
    },
    {
      day: "30",
      celebrations: [
        {
          title:
            "Consecration of the Church of St. Mark the Evangelist and the Apparition of his Holy head",
        },
        {
          title: "Departure of St. Abraham (Ibrahim) the Hermit of Memphis",
        },
      ],
    },
  ],
  Hathor: [
    {
      day: "01",
      celebrations: [
        {
          title:
            "Martyrdom of the Sts Maximus, Numitius, Victor (Boctor), and Philip (Philopus)",
        },
        {
          title: "Commemoration of St. Cleopas the Apostle and His Companion",
        },
      ],
    },
    {
      day: "02",
      celebrations: [
        {
          title: "Departure of St. Peter III, the 27th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "03",
      celebrations: [
        {
          title: "Departure of St. Cyriacus the Anchorite.",
        },
        {
          title: "Departure of St. Athanasius & his sister St. Irene",
        },
      ],
    },
    {
      day: "04",
      celebrations: [
        {
          title: "Martyrdom of Sts. John & James, Bishops of Persia",
        },
        {
          title: "Martyrdom of St. Epimachus & St. Adrianus (Azarianus)",
        },
        {
          title: "Martyrdom of St. Thomas of Damascus",
        },
      ],
    },
    {
      day: "05",
      celebrations: [
        {
          title: "Appearance of the Head of Saint Longinus, the Soldier.",
        },
        {
          title:
            "Martyrdom of St. Timothy and the Relocation of the Body of St. Theodore, the Prince, to Shotb",
        },
        {
          title: "Departure of St. Joseph II, the 115th Pope of Alexandria.",
        },
        {
          title:
            "Enthronement of Pope Shenouda III, the 117th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "06",
      celebrations: [
        {
          title: "Departure of St. Felix, the 26th Bishop of Rome.",
        },
        {
          title:
            "Consecration of the Church of the Virgin in the Muharraq Monastery",
        },
      ],
    },
    {
      day: "07",
      celebrations: [
        {
          title: "Martyrdom of St. George of Alexandria",
        },
        {
          title: "Martyrdom of St. Nehroua of Fayyum",
        },
        {
          title: "Departure of St. Mina, Bishop of Tamai (Thmoui)",
        },
        {
          title: "Consecration of the Church of St. George of Cappadocia",
        },
        {
          title:
            "Departure of Metropolitan Archbishop Athanasius, of the Metropolis of Beni Suef and El-Bahnasa.",
        },
      ],
    },
    {
      day: "08",
      celebrations: [
        {
          title: "Commemoration of the Four Incorporeal Beasts",
        },
      ],
    },
    {
      day: "09",
      celebrations: [
        {
          title: "Departure of St. Isaac, the 41st Pope of Alexandria.",
        },
        {
          title:
            "Assembly of the First Ecumenical Council at Nicaea in the year 325 AD.",
        },
      ],
    },
    {
      day: "10",
      celebrations: [
        {
          title: "Martyrdom of St. Sophia & the Fifty Virgins",
        },
        {
          title:
            "Assembly of a Council in Rome because of the Feast of Theophany and Lent",
        },
      ],
    },
    {
      day: "11",
      celebrations: [
        {
          title: "Departure of St. Anne (Hannah), the mother of the Theotokos",
        },
        {
          title:
            "Martyrdom of St. Archelaus and the Martyrdom of Elisha the Hegumen",
        },
      ],
    },
    {
      day: "12",
      celebrations: [
        {
          title: "Commemoration of Michael, the Archangel.",
        },
      ],
    },
    {
      day: "13",
      celebrations: [
        {
          title: "Departure of St. Timothy, Bishop of Ansena",
        },
        {
          title: "Departure of St. Zacharias, the 64th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "14",
      celebrations: [
        {
          title: "Departure of St. Martinus (Martin), Bishop of Thrace",
        },
        {
          title:
            "Departure of Metropolitan Archbishop Mikhail, of the Metropolis of Asyut.",
        },
      ],
    },
    {
      day: "15",
      celebrations: [
        {
          title: "Martyrdom of St. Menas, the Wonder Worker.",
        },
      ],
    },
    {
      day: "16",
      celebrations: [
        {
          title:
            "Beginning of the Fast of the Nativity (Advent) in the Coptic Church",
        },
        {
          title: "Consecration of the Church of St. Abu-Nofer (Onuphrius)",
        },
        {
          title: "Martyrdom of St. Yostus, the Bishop",
        },
        {
          title: "Martyrdom of St. Wannas",
        },
      ],
    },
    {
      day: "17",
      celebrations: [
        {
          title: "Departure of St. John Chrysostom.",
        },
      ],
    },
    {
      day: "18",
      celebrations: [
        {
          title: "Martyrdom of the Two Saints: Atrasis & Yoana (Junia)",
        },
        {
          title: "Martyrdom of St. Philip the Apostle.",
        },
      ],
    },
    {
      day: "19",
      celebrations: [
        {
          title: "Consecration of the Church of St. Sergius & St. Bacchus",
        },
        {
          title:
            "Commemoration of the preaching of St. Bartholomew the Apostle",
        },
      ],
    },
    {
      day: "20",
      celebrations: [
        {
          title: "Departure of St. Anianus, the 2nd Pope of Alexandria.",
        },
        {
          title:
            "Consecration of the Churches of Prince Theodore, the Son of John El-Shotbe, and Prince Theodore El-Mishreke",
        },
      ],
    },
    {
      day: "21",
      celebrations: [
        {
          title:
            "Commemoration of the Holy Virgin Saint Mary, the Mother of God (Theotokos).",
        },
        {
          title: "Departure of St. Gregory, the Wonder Worker.",
        },
        {
          title: "Departure of St. Cosma II, the 54th Pope of Alexandria.",
        },
        {
          title:
            "Commemoration of the Holy Martyrs Sts. Alphaeus, Zacchaeus, Romanus, & John",
        },
        {
          title:
            "Commemoration of the Sts Thomas, Victor, and Isaac of the City of Ashmunein",
        },
      ],
    },
    {
      day: "22",
      celebrations: [
        {
          title:
            "Martyrdom of Sts Cosmas, Damian, their Brothers & their Mother.",
        },
      ],
    },
    {
      day: "23",
      celebrations: [
        {
          title: "Departure of St. Cornelius the Centurion.",
        },
        {
          title: "Consecration of the Church of St. Marina",
        },
      ],
    },
    {
      day: "24",
      celebrations: [
        {
          title: "Commemoration of the Twenty-Four Priests",
        },
      ],
    },
    {
      day: "25",
      celebrations: [
        {
          title: "Martyrdom of St. Mercurius, the Saint with the Two Swords.",
        },
      ],
    },
    {
      day: "26",
      celebrations: [
        {
          title:
            "Martyrdom of Sts. Tiburtius (Thiborinos), Valerian (Balaryanos), & Maximus.",
        },
        {
          title: "Commemoration of St. Gregory, Bishop of Nyssa.",
        },
      ],
    },
    {
      day: "27",
      celebrations: [
        {
          title: "Martyrdom St. James the Mangled (Sawn)",
        },
      ],
    },
    {
      day: "28",
      celebrations: [
        {
          title: "Martyrdom of St. Sarapamon, Bishop of Niku",
        },
      ],
    },
    {
      day: "29",
      celebrations: [
        {
          title: "Martyrdom of St. Peter, the 17th Pope of Alexandria.",
        },
        {
          title: "Martyrdom of St. Clement, the 4th Bishop of Rome.",
        },
      ],
    },
    {
      day: "30",
      celebrations: [
        {
          title: "Departure of St. Acacius, Patriarch of Constantinople.",
        },
        {
          title: "Martyrdom of St. Macarius",
        },
        {
          title:
            "Consecration of the Church of Sts. Cosmas, Damian, Their Brothers and Their Mother",
        },
      ],
    },
  ],
  Koiahk: [
    {
      day: "01",
      celebrations: [
        {
          title: "Departure of St. Peter Elrahawy, Bishop of Gaza",
        },
        {
          title: "Consecration of the Church of St. Shenouda",
        },
      ],
    },
    {
      day: "02",
      celebrations: [
        {
          title: "Departure of the St. Hor, the Monk ",
        },
        {
          title: "Commemoration of St. Hermina the Anchorite",
        },
        {
          title: "Martyrdom of the church of St. Peter & St. Paul",
        },
      ],
    },
    {
      day: "03",
      celebrations: [
        {
          title: "Entrance of St. Mary into the Temple at Jerusalem.",
        },
        {
          title: "Martyrdom of St. Salib",
        },
      ],
    },
    {
      day: "04",
      celebrations: [
        {
          title:
            "Martyrdom of St. Andrew the Apostle, the Brother of St. Peter.",
        },
      ],
    },
    {
      day: "05",
      celebrations: [
        {
          title: "Departure of Nahum, the Prophet.",
        },
        {
          title: "Martyrdom of St. Victor (Boctor) of Asyut",
        },
        {
          title: "Martyrdom of St. Isidore (Isidorus)",
        },
      ],
    },
    {
      day: "06",
      celebrations: [
        {
          title: "Martyrdom of St. Anatolius (Anatole)",
        },
        {
          title: "Martyrdom of St. Batalus",
        },
      ],
    },
    {
      day: "07",
      celebrations: [
        {
          title: "Martyrdom of St. Banina & St. Banau",
        },
        {
          title: "Departure of St. Abraham, the 62nd Pope of Alexandria.",
        },
        {
          title: "Departure of St. Matthew the Poor.",
        },
        {
          title: "Enthronement of St. John XIX, the 113th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "08",
      celebrations: [
        {
          title: "Martyrdom of the St. Barbara & St. Juliana",
        },
        {
          title: "Martyrdom of the St. Paisus (Isi) & His Sister St. Thecla",
        },
        {
          title:
            "Departure of St. Heraclas (Theoclas), the 13th Pope of Alexandria.",
        },
        {
          title:
            "Departure of St. Samuel the Confessor, Abbot of El-Qualamon Monastery",
        },
        {
          title: "Departure of St. Yostos el-Antony, the Silent Monk.",
        },
      ],
    },
    {
      day: "09",
      celebrations: [
        {
          title: "Departure of St. Poemen, the Confessor",
        },
      ],
    },
    {
      day: "10",
      celebrations: [
        {
          title: "Martyrdom of St. Shura of Shinshif",
        },
        {
          title: "Departure of St. Theophilus II, the 60th Pope of Alexandria.",
        },
        {
          title: "Relocation of the Body of St. Severus, Patriarch of Antioch",
        },
        {
          title: "Departure of St. Nicholas, the Confessor, Bishop of Myra.",
        },
      ],
    },
    {
      day: "11",
      celebrations: [
        {
          title: "Departure of the St. Pijimi.",
        },
      ],
    },
    {
      day: "12",
      celebrations: [
        {
          title: "Commemoration of Michael, the Archangel.",
        },
        {
          title: "Commemoration of St. John the Confessor",
        },
        {
          title: "Departure of St. Hedra, Bishop of Aswan",
        },
        {
          title:
            "Assembly of the Council at Rome in 249 AD. Against Benates (Novatus) the Priest",
        },
        {
          title: "Departure of St. Mark VIII, the 108th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "13",
      celebrations: [
        {
          title: "Martyrdom of St. Barsanuphius",
        },
        {
          title: "Departure of St. Apraxios (Abracius).",
        },
        {
          title: "Consecration of the Church of St. Misael, the Anchorite.",
        },
        {
          title: "St. Zali, disciple of St. Matthew",
        },
      ],
    },
    {
      day: "14",
      celebrations: [
        {
          title: "Martyrdom of St. Ammonius, Bishop of Esna",
        },
        {
          title: "Martyrdom of St. Behnam & His Sister St. Sarah",
        },
        {
          title:
            "Martyrdom of Sts. Simeon of Menouf, Abba Hor, and Abba Mina the Elder",
        },
        {
          title: "Departure of St. Christodolos, the 66th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "15",
      celebrations: [
        {
          title: "Martyrdom of St. Asbah",
        },
        {
          title: "Martyrdom of St. Amsah al-Qifti",
        },
        {
          title:
            "Departure of St. Gregory the Illuminator, the Patriarch of Armenia.",
        },
      ],
    },
    {
      day: "16",
      celebrations: [
        {
          title:
            "Departure of the Righteous Gideon, One of the Judges of Israel.",
        },
        {
          title: "Martyrdom of Sts. Harouadi, Ananias & Khouzi of Akhmim",
        },
        {
          title: "Martyrdom of St. Eulogius & St. Arsenius",
        },
        {
          title: "Consecration of the Church of St. James the Persian",
        },
      ],
    },
    {
      day: "17",
      celebrations: [
        {
          title:
            "Departure of St. Luke the Stylite and the Relocation of His Holy Relics",
        },
        {
          title: "Commemoration of St. Elisa the Anchorite",
        },
      ],
    },
    {
      day: "18",
      celebrations: [
        {
          title:
            "Commemoration of the Relocation of the Relics of St. Titus to Constantinople",
        },
        {
          title:
            "Commemoration of St. Heracleas the Martyr and St. Philemon the Priest",
        },
      ],
    },
    {
      day: "19",
      celebrations: [
        {
          title:
            "Departure of St. John, Bishop of El-Borollos, who gathered the Biographies of the Saints (The Synaxarion)",
        },
      ],
    },
    {
      day: "20",
      celebrations: [
        {
          title: "Departure of Haggai, the Prophet.",
        },
        {
          title: "Commemoration of St. Elias, Bishop of al-Muharraq",
        },
      ],
    },
    {
      day: "21",
      celebrations: [
        {
          title:
            "Commemoration of the Holy Virgin Saint Mary, the Mother of God (Theotokos)",
        },
        {
          title: "Martyrdom of St. Barnabas, one of the Seventy Apostles.",
        },
      ],
    },
    {
      day: "22",
      celebrations: [
        {
          title: "Commemoration of Gabriel, the Archangel.",
        },
        {
          title: "Departure of St. Anastasius, the 36th Pope of Alexandria",
        },
      ],
    },
    {
      day: "23",
      celebrations: [
        {
          title: "Departure of David, the Prophet and King",
        },
        {
          title: "Departure of St. Timothy, the Anchorite",
        },
      ],
    },
    {
      day: "24",
      celebrations: [
        {
          title: "Martyrdom of St. Ignatius, Patriarch of Antioch",
        },
        {
          title: "Departure of St. Philogonius, Patriarch of Antioch",
        },
        {
          title:
            "Commemoration of the Nativity of St. Takla Haymanot, the Ethiopian.",
        },
      ],
    },
    {
      day: "25",
      celebrations: [
        {
          title: "Departure of St. John Kama (Khame)",
        },
      ],
    },
    {
      day: "26",
      celebrations: [
        {
          title: "Martyrdom of St. Anastasia.",
        },
        {
          title: "Commemoration of St. Juliana the Martyr.",
        },
      ],
    },
    {
      day: "27",
      celebrations: [
        {
          title: "Martyrdom of St. Psote, the Bishop of Ebsay",
        },
      ],
    },
    {
      day: "28",
      celebrations: [
        {
          title: "The Glorious Nativity of Our Lord Jesus Christ (Christmas).",
        },
        {
          title: "Martyrdom of 150 Men and 24 Women from Ansena",
        },
      ],
    },
    {
      day: "29",
      celebrations: [
        {
          title: "Feast of the Nativity of Our Lord Jesus Christ (Christmas).",
        },
      ],
    },
    {
      day: "30",
      celebrations: [
        {
          title: "The Adoration of the Magi.",
        },
        {
          title: "Departure of St. John, Archpriest of Scetis",
        },
      ],
    },
  ],
  Tobe: [
    {
      day: "01",
      celebrations: [
        {
          title: "Martyrdom of St. Stephen, the Archdeacon",
        },
        {
          title: "Martyrdom of St. Leontius.",
        },
        {
          title: "Martyrdom of Aesculapius and Dioscorus of Akhmim",
        },
      ],
    },
    {
      day: "02",
      celebrations: [
        {
          title: " Departure of St. Theonas, the 16th Pope of Alexandria.",
        },
        {
          title:
            "Martyrdom of St. Callinicus (Gallinicus), Bishop of Letopolis.",
        },
      ],
    },
    {
      day: "03",
      celebrations: [
        {
          title:
            "Commemoration of the Slain Children of Bethlehem by the Order of Herod the Great.",
        },
      ],
    },
    {
      day: "04",
      celebrations: [
        {
          title: "Departure of St. John the Evangelist.",
        },
      ],
    },
    {
      day: "05",
      celebrations: [
        {
          title: "Martyrdom of St. Eusignius the Soldier.",
        },
      ],
    },
    {
      day: "06",
      celebrations: [
        {
          title: "Commemoration of the Circumcision of the Lord Christ.",
        },
        {
          title: "Ascension of Elijah, the Prophet.",
        },
        {
          title: "Departure of St. Marcianus, the 8th Pope of Alexandria.",
        },
        {
          title: "Departure of St. Basil the Great, Bishop Of Caesarea.",
        },
      ],
    },
    {
      day: "07",
      celebrations: [
        {
          title: "Departure of St. Silvester, Bishop of Rome",
        },
      ],
    },
    {
      day: "08",
      celebrations: [
        {
          title: "Consecration of the Church of St. Macarius",
        },
        {
          title: "Departure of St. Andronicus, the 37th Pope of Alexandria",
        },
        {
          title: "Departure of St. Benjamin, the 38th Pope of Alexandria",
        },
      ],
    },
    {
      day: "09",
      celebrations: [
        {
          title:
            "Departure of St. Abraam, friend of St. George (Ga'orgi) of Scetes",
        },
        {
          title:
            "Departure of Bishop Karas, the 1st Bishop of the United States",
        },
      ],
    },
    {
      day: "10",
      celebrations: [
        {
          title: "Paramouni of Holy Theophany.",
        },
        {
          title: "Departure of St. Demetrius II, the 111th Pope of Alexandria.",
        },
        {
          title: "Commemoration of St. Justus, disciple of St. Samuel",
        },
      ],
    },
    {
      day: "11",
      celebrations: [
        {
          title:
            "Holy Theophany of Our Lord, God and Savior, Jesus Christ (Baptism of the Lord).",
        },
      ],
    },
    {
      day: "12",
      celebrations: [
        {
          title: "Commemoration of Michael, the Archangel.",
        },
        {
          title: "Martyrdom of St. Theodore El-Mishreke (the Oriental).",
        },
        {
          title: "Martyrdom of St. Anatole (Anatolius).",
        },
      ],
    },
    {
      day: "13",
      celebrations: [
        {
          title: "Commemoration of the Miracle at Cana.",
        },
        {
          title: "Departure of St. Theophilus, the Monk.",
        },
        {
          title: "Martyrdom of St. Demiana.",
        },
      ],
    },
    {
      day: "14",
      celebrations: [
        {
          title: "Martyrdom of St. Mohrael.",
        },
        {
          title: "Departure of St. Archiledis (Arselidas).",
        },
        {
          title:
            "Departure of St. Maximus, Brother of St. Domatius, sons of the Roman Emperor Valentinian I.",
        },
      ],
    },
    {
      day: "15",
      celebrations: [
        {
          title: "Departure of Obadiah, the Prophet.",
        },
      ],
    },
    {
      day: "16",
      celebrations: [
        {
          title: "Martyrdom of St. Philotheus.",
        },
        {
          title: "Departure of St. John IV, the 48th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "17",
      celebrations: [
        {
          title:
            "Departure of St. Domatius, Brother of St. Maximus, sons of the Roman Emperor Valentinian I.",
        },
        {
          title: "Departure of St. Yousab el-Abbah, Bishop of Girga,",
        },
      ],
    },
    {
      day: "18",
      celebrations: [
        {
          title: "Departure of St. James, Bishop of Nisibis.",
        },
      ],
    },
    {
      day: "19",
      celebrations: [
        {
          title:
            "Discovery of the Relics of St. Abahor (Pihour) St. Bisoura (Pisoura) & their Mother St. Ampira (Asra).",
        },
      ],
    },
    {
      day: "20",
      celebrations: [
        {
          title: "Departure of St. Prochorus, one of the Seventy Disciples.",
        },
        {
          title:
            "Commemoration of the Consecration of the Church of St. John, the Owner of the Golden Gospel, and the Transfer of His Relics to It.",
        },
        {
          title:
            "Commemoration of the Martyrdom of St. Behna (Bahnou) and St. Kloag (Bagoug), the Priest.",
        },
      ],
    },
    {
      day: "21",
      celebrations: [
        {
          title:
            "Commemoration of the Holy Virgin Saint Mary, the Mother of God (Theotokos)",
        },
        {
          title: "Departure of St. Hilaria, Daughter of Emperor Zeno.",
        },
        {
          title:
            "Departure of St. Gregory of Nyssa, Brother of St. Basil the Great.",
        },
      ],
    },
    {
      day: "22",
      celebrations: [
        {
          title: "Departure of St. Anthony the Great.",
        },
      ],
    },
    {
      day: "23",
      celebrations: [
        {
          title: "Martyrdom of St. Timothy, the Apostle.",
        },
        {
          title: "Departure of St. Cyril IV, the 110th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "24",
      celebrations: [
        {
          title: "Departure of St. Mary the Ascetic (The Shut-In).",
        },
        {
          title: "Martyrdom of St. Bisada (Psati), the Priest.",
        },
      ],
    },
    {
      day: "25",
      celebrations: [
        {
          title: "Departure of St. Peter, the Worshipper.",
        },
        {
          title: "Martyrdom of St. Askala (Asela), the Ascetic.",
        },
      ],
    },
    {
      day: "26",
      celebrations: [
        {
          title: "Martyrdom of the Forty-Nine Saints, the Elders of Scetis",
        },
        {
          title: "Departure of St. Anastasia.",
        },
      ],
    },
    {
      day: "27",
      celebrations: [
        {
          title: "Martyrdom of St. Sarapion.",
        },
        {
          title: "Commemoration of Sariel, the Archangel.",
        },
        {
          title: "Relocation of the Relics of St. Timothy, the Apostle.",
        },
        {
          title: "Martyrdom of St. Phoebammon (Abu-Fam), the Soldier.",
        },
      ],
    },
    {
      day: "28",
      celebrations: [
        {
          title: "Martyrdom of St. Clement.",
        },
        {
          title: "Martyrdom of St. Anba Kaou.",
        },
      ],
    },
    {
      day: "29",
      celebrations: [
        {
          title: "Departure of St. Eksani (St. Xene).",
        },
        {
          title: "Commemoration of St. Seriakos (Syriacus), the Fighter.",
        },
      ],
    },
    {
      day: "30",
      celebrations: [
        {
          title:
            "Martyrdom of Sts. Pistis, Helpis, Agape, & their Mother Sophia.",
        },
        {
          title: "Departure of St. Andrews the Samuelite.",
        },
      ],
    },
  ],
  Meshir: [
    {
      day: "01",
      celebrations: [
        {
          title:
            "Commemoration of the Second Ecumenical Council of Constantinople, in 381",
        },
        {
          title:
            "Commemoration of the Consecration of the Church of St. Peter, the Seal of Martyrs.",
        },
      ],
    },
    {
      day: "02",
      celebrations: [
        {
          title: " Departure of St. Paul, the First Hermit.",
        },
        {
          title: "Departure of St. Longinus, Abbot of El-Zugag Monastery.",
        },
      ],
    },
    {
      day: "03",
      celebrations: [
        {
          title: "Departure of St. James, the Ascetic.",
        },
      ],
    },
    {
      day: "04",
      celebrations: [
        {
          title: "Martyrdom of St. Agabus, one of the Seventy Disciples.",
        },
      ],
    },
    {
      day: "05",
      celebrations: [
        {
          title: "Departure of St. Agrippinus, the 10th Pope of Alexandria.",
        },
        {
          title: "Commemoration of the Sts. Anba Bishay and St. Anba Abanoub.",
        },
        {
          title: "Departure of St. Apollo, friend of St. Anba Abib.",
        },
        {
          title:
            "Commemoration of the Relocation of the Relics of the Forty-Nine Elders of the Wilderness of Scetis.",
        },
      ],
    },
    {
      day: "06",
      celebrations: [
        {
          title: "Appearance of the Body of St. Hippolytus of Rome.",
        },
        {
          title:
            "Martyrdom of the Sts. Abakir, John, the Three Virgins and their Mother.",
        },
      ],
    },
    {
      day: "07",
      celebrations: [
        {
          title: "Departure of St. Alexander II, the 43rd Pope of Alexandria",
        },
        {
          title: "Departure of St. Theodoros I, the 45th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "08",
      celebrations: [
        {
          title: "Feast of Presenting the Lord Christ in the Temple.",
        },
        {
          title: "Martyrdom of the Twenty-One Men in Libya.",
        },
        {
          title: "Commemoration of all contemporary Martyrs.",
        },
      ],
    },
    {
      day: "09",
      celebrations: [
        {
          title: "Departure of St. Barsauma, the Father of the Syrian Monks",
        },
        {
          title: "Martyrdom of St. Paul the Syrian",
        },
      ],
    },
    {
      day: "10",
      celebrations: [
        {
          title: "Martyrdom of St. James the Apostle, Son of Alphaeus.",
        },
        {
          title: "Martyrdom of St. Justus, Son of Roman Emperor Numerian",
        },
        {
          title: "Departure of St. Isidore of Pelusium.",
        },
        {
          title: "Martyrdom of St. Philo, Bishop of the Persians.",
        },
      ],
    },
    {
      day: "11",
      celebrations: [
        {
          title: "Martyrdom of St. Fabian (Fabrianus), Bishop of Rome.",
        },
      ],
    },
    {
      day: "12",
      celebrations: [
        {
          title: "Commemoration of Michael, the Archangel.",
        },
        {
          title: "Departure of St. Gelasius.",
        },
      ],
    },
    {
      day: "13",
      celebrations: [
        {
          title:
            "Martyrdom of St. Sergius of Atripe, His Father, Mother, Sister, and Many Others with Them.",
        },
        {
          title: "Departure of St. Timothy III, the 32nd Pope of Alexandria.",
        },
      ],
    },
    {
      day: "14",
      celebrations: [
        {
          title: "Departure of St. Severus, Patriarch of Antioch.",
        },
        {
          title:
            "Departure of St. James (Yacobus), the 50th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "15",
      celebrations: [
        {
          title: "Departure of St. Zechariah, the Prophet.",
        },
        {
          title:
            "Consecration of the First Church Dedicated for the Forty Martyrs of Sebaste",
        },
        {
          title: "Departure of Saint Paphnoute (Paphnotius).",
        },
      ],
    },
    {
      day: "16",
      celebrations: [
        {
          title:
            "Departure of St. Elizabeth, the mother of St. John the Baptist.",
        },
      ],
    },
    {
      day: "17",
      celebrations: [
        {
          title: "Martyrdom of St. Mina, the Monk.",
        },
      ],
    },
    {
      day: "18",
      celebrations: [
        {
          title:
            "Departure of St. Malatius the Confessor, Patriarch of Antioch.",
        },
      ],
    },
    {
      day: "19",
      celebrations: [
        {
          title:
            "Commemoration of the Relocation of the Relics of St. Martianus, the Monk.",
        },
      ],
    },
    {
      day: "20",
      celebrations: [
        {
          title: "Departure of St. Peter, the 21st Pope of Alexandria.",
        },
        {
          title:
            "Commemoration of Sts. Basil, Theodore and Timothy, the Martyrs.",
        },
      ],
    },
    {
      day: "21",
      celebrations: [
        {
          title:
            "Commemoration of the Holy Virgin Saint Mary, the Mother of God (Theotokos)",
        },
        {
          title: "Martyrdom of St. Onesimus, the Disciple of St. Paul.",
        },
        {
          title: "Departure of St. Gabriel, the 57th Pope of Alexandria.",
        },
        {
          title: "Departure of St. Zacharias, Bishop of Sakha.",
        },
      ],
    },
    {
      day: "22",
      celebrations: [
        {
          title:
            "Departure of St. Maruta (Maruthas), the Bishop of Marjferqat.",
        },
      ],
    },
    {
      day: "23",
      celebrations: [
        {
          title: "Martyrdom of St. Eusebius, Son of Basilides, the Minister.",
        },
      ],
    },
    {
      day: "24",
      celebrations: [
        {
          title: "Departure of St. Agapetus (Agapius), the Bishop.",
        },
        {
          title: "Martyrdom of St. Timothy and St. Matthias.",
        },
      ],
    },
    {
      day: "25",
      celebrations: [
        {
          title: "Martyrdom of Sts. Archippus, Philemon and Lycia the Virgin.",
        },
        {
          title: "Martyrdom of St. Quona (Kona) and St. Mina.",
        },
        {
          title: "Commemoration of St. Fana, the Hermit.",
        },
      ],
    },
    {
      day: "26",
      celebrations: [
        {
          title: "Departure of Hosea, the Prophet.",
        },
        {
          title: "Martyrdom of St. Zadok and the 128 who were with Him.",
        },
      ],
    },
    {
      day: "27",
      celebrations: [
        {
          title: "Departure of St. Eustathius, Patriarch of Antioch",
        },
      ],
    },
    {
      day: "28",
      celebrations: [
        {
          title: "Martyrdom of St. Theodore, the Roman.",
        },
      ],
    },
    {
      day: "29",
      celebrations: [
        {
          title: "Martyrdom of St. Polycarp, Bishop of Smyrna.",
        },
      ],
    },
    {
      day: "30",
      celebrations: [
        {
          title: "Appearance of the Head of St. John the Baptist.",
        },
        {
          title:
            "Departure of St. Cyril VI (Kyrillos), the 116th Pope of Alexandria.",
        },
      ],
    },
  ],
  Paremhotep: [
    {
      day: "01",
      celebrations: [
        {
          title: "Martyrdom of St. Alexandrus",
        },
        {
          title:
            "Commemoration of St. Marcura, the BishopCommemoration of St. Marcura, the Bishop",
        },
        {
          title: "Departure of St. Narcissus, Bishop of Jerusalem.",
        },
      ],
    },
    {
      day: "02",
      celebrations: [
        {
          title: "Martyrdom of St. Macrobius (Makrawy), Bishop of Nikiû ",
        },
      ],
    },
    {
      day: "03",
      celebrations: [
        {
          title: "Departure of St. Cosmas III, the 58th Pope of Alexandria.",
        },
        {
          title: "Martyrdom of St. Porphyry",
        },
        {
          title: "Departure of St. Hadid, the priest",
        },
      ],
    },
    {
      day: "04",
      celebrations: [
        {
          title: "Assembly of the Holy Council on the island of Bani-Omar",
        },
        {
          title: "Martyrdom of St. Haboulyous (Hanulius), the Prince of Perga",
        },
      ],
    },
    {
      day: "05",
      celebrations: [
        {
          title:
            "Departure of St. Serapamon, Archpriest of the Monastery of St. John the Dwarf",
        },
        {
          title: "Martyrdom of St. Eudexia.",
        },
        {
          title: "Martyrdom of St. Peter, the priest.",
        },
      ],
    },
    {
      day: "06",
      celebrations: [
        {
          title: "Martyrdom of St. Dioscorus",
        },
        {
          title: "Departure of St. Theodotus, Bishop of Corinth",
        },
      ],
    },
    {
      day: "07",
      celebrations: [
        {
          title: "Martyrdom of Sts. Philemon & St. Apollonius",
        },
        {
          title: "Martyrdom of St. Mary, the Israelite",
        },
      ],
    },
    {
      day: "08",
      celebrations: [
        {
          title: "Martyrdom of St. Matthias, the Apostle.",
        },
        {
          title: "Martyrdom of St. Arianus, the Governor of Ansena.",
        },
        {
          title: "Departure of St. Julian, the 11th Pope of Alexandria.",
        },
        {
          title: "Departure of Fr. Faltaous El Souriani",
        },
        {
          title:
            "Departure of Pope Shenouda III, the 117th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "09",
      celebrations: [
        {
          title: "Departure of St. Konan the Syrian",
        },
        {
          title:
            "Martyrdom of Sts. Abrianus, Amrata his wife, Eusebius, Armanius, and the Forty Martyrs.",
        },
      ],
    },
    {
      day: "10",
      celebrations: [
        {
          title: "Commemoration of the Appearance of the Glorious Cross",
        },
      ],
    },
    {
      day: "11",
      celebrations: [
        {
          title: "Martyrdom of St. Basilaos, the Bishop",
        },
      ],
    },
    {
      day: "12",
      celebrations: [
        {
          title: "Commemoration of Michael, the Archangel",
        },
        {
          title:
            "Commemoration of the revealing of the Virginity of St. Demetrius, the 12th Pope of Alexandria.",
        },
        {
          title: "Martyrdom of St. Malachias of Palestine",
        },
        {
          title: "Martyrdom of St. Glathinos in Damascus",
        },
        {
          title: "Departure of Fr. Bishoy Kamel",
        },
      ],
    },
    {
      day: "13",
      celebrations: [
        {
          title: "Departure of St. Dionysius, the 14th Pope of Alexandria",
        },
        {
          title:
            "Return of St. Macarius the Great & St. Macarius of Alexandria, from Exile.",
        },
        {
          title: "Martyrdom of the Forty Martyrs of Sebastia",
        },
      ],
    },
    {
      day: "14",
      celebrations: [
        {
          title: "Departure of St. Cyril III, the 75th Pope of Alexandria.",
        },
        {
          title: "Martyrdom of St. Sinouti el-Bahnasa",
        },
        {
          title: "Martyrdom of the Sts. Eugenius, Agathodorus and Elpidius",
        },
      ],
    },
    {
      day: "15",
      celebrations: [
        {
          title: "Departure of St. Sarah the nun",
        },
        {
          title: "Martyrdom of St. Helias of Hnes",
        },
      ],
    },
    {
      day: "16",
      celebrations: [
        {
          title: "Departure Of St. Michael I, the 46th Pope of Alexandria",
        },
      ],
    },
    {
      day: "17",
      celebrations: [
        {
          title: "Departure of Lazarus, the beloved of the Lord.",
        },
        {
          title:
            "Commemoration of the St. George the Ascetic, St. Belasius the Martyr, & St. Joseph the Bishop",
        },
        {
          title: "Departure of St. Basilius, Bishop of Jerusalem",
        },
        {
          title: "Martyrdom of St. Sidhom Bishay in Damietta.",
        },
      ],
    },
    {
      day: "18",
      celebrations: [
        {
          title: "Martyrdom of St. Isidore, friend of St. Sina the Soldier",
        },
      ],
    },
    {
      day: "19",
      celebrations: [
        {
          title: "Martyrdom of St. Aristobulus, the Apostle.",
        },
        {
          title:
            "Martyrdom of the Sts. Alexander, Agabius, Alexander, Timolaos, Dionysius, Romulus, and Blesius (Valesius)",
        },
      ],
    },
    {
      day: "20",
      celebrations: [
        {
          title: "Raising of Lazarus from the dead.",
        },
        {
          title:
            "Departure Of the St. Michael III, the 56th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "21",
      celebrations: [
        {
          title:
            "Commemoration of the Holy Virgin St. Mary, the Mother of God (Theotokos).",
        },
        {
          title: "Commemoration of the visit of Our Lord Christ to Bethany.",
        },
        {
          title:
            "Consultation of the Chief Priests to put the righteous Lazarus to death",
        },
      ],
    },
    {
      day: "22",
      celebrations: [
        {
          title: "Departure of St. Michael, Bishop of Naqadah",
        },
        {
          title: "Departure of St. Cyril, Bishop of Jerusalem.",
        },
      ],
    },
    {
      day: "23",
      celebrations: [
        {
          title: "Departure of Daniel, the Prophet.",
        },
      ],
    },
    {
      day: "24",
      celebrations: [
        {
          title: "Apparition of Our Lady of Zeitoun.",
        },
        {
          title: "Departure of St. Macarius I, the 59th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "25",
      celebrations: [
        {
          title:
            "Departure of St. Onesiphorous (Friska), one of the Seventy Apostles",
        },
        {
          title: "Departure of St. Matthew III, the 100th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "26",
      celebrations: [
        {
          title: "Departure of St. Euphrasia, the Virgin.",
        },
        {
          title: "Departure of St. Peter VI, the 104th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "27",
      celebrations: [
        {
          title: "Crucifixion of Our Lord Jesus Christ",
        },
        {
          title: "Departure of St. Macarius the Great.",
        },
        {
          title: "Martyrdom of St. Domicos",
        },
      ],
    },
    {
      day: "28",
      celebrations: [
        {
          title: "Departure of the Righteous Emperor Constantine the Great",
        },
        {
          title: "Departure of St. Peter VII, the 109th Pope of Alexandria",
        },
        {
          title:
            "Commemoration of St. Sarapamon, known as 'The Veiled' Bishop of El-Monufia",
        },
      ],
    },
    {
      day: "29",
      celebrations: [
        {
          title: "Commemoration of the Life giving Annunciation",
        },
        {
          title: "Resurrection of Our Lord Christ from the dead",
        },
      ],
    },
    {
      day: "30",
      celebrations: [
        {
          title: "Commemoration of the Archangel Gabriel, the Announcer",
        },
        {
          title:
            "Commemoration of the Transfer of the Relies of Saint James, known as the Mangled",
        },
        {
          title: "Commemoration of Samson, One of the Judges of Israel",
        },
      ],
    },
  ],
  Parmoute: [
    {
      day: "01",
      celebrations: [
        {
          title: "Departure of Aaron, the priest.",
        },
        {
          title: "Departure of St. Silvanus the monk",
        },
        {
          title: "Berber attack on the Monastery of St. Macarius",
        },
        {
          title:
            "Daesh bombing on St. Mark Cathedral in Alexandria & St. George Church in Tanta, Egypt",
        },
      ],
    },
    {
      day: "02",
      celebrations: [
        {
          title:
            "Martyrdom of St. James the Apostle, brother of St. John the Apostle ",
        },
        {
          title: "Martyrdom of St. Christopher",
        },
        {
          title: "Departure of St. John IX, the 81st Pope of Alexandria",
        },
      ],
    },
    {
      day: "03",
      celebrations: [
        {
          title: "Departure of St. John, Bishop of Jerusalem",
        },
        {
          title: "Departure of St. Michael V, the 71st Pope of Alexandria.",
        },
        {
          title: "Martyrdom of St. Theodorus",
        },
      ],
    },
    {
      day: "04",
      celebrations: [
        {
          title:
            "Martyrdom of the Saints Victor, Decius, Eirene the Virgin, and those with them men, women and virgins.",
        },
      ],
    },
    {
      day: "05",
      celebrations: [
        {
          title: "Commemoration of the Ezekiel the Prophet, the son of Buzi",
        },
        {
          title: "Martyrdom of St. Hepatius, Bishop of Gangra",
        },
      ],
    },
    {
      day: "06",
      celebrations: [
        {
          title:
            "Commemoration of the Appearance of the Lord to St. Thomas the Apostle after His Resurrection.",
        },
        {
          title: "Departure of St. Mary of Egypt",
        },
        {
          title: "Departure of St. Abdel Messih El-Makari.",
        },
      ],
    },
    {
      day: "07",
      celebrations: [
        {
          title:
            "Departure of the Righteous Joachim, The Lord Christ Grandfather.",
        },
        {
          title: "Departure of St. Macrobius",
        },
        {
          title: "Departure of Saints Agapius, Theodora, and Metruf",
        },
      ],
    },
    {
      day: "08",
      celebrations: [
        {
          title:
            "Martyrdom of the Holy Virgins: Saints Agape, Eirene, & Shiona",
        },
        {
          title:
            "Martyrdom of the One Hundred and Fifty believers by the hand of the King of Persia",
        },
      ],
    },
    {
      day: "09",
      celebrations: [
        {
          title: "Departure of St. Zosimas.",
        },
        {
          title:
            "Commemoration of the Miracle that took place by the hand of St. Sinuthius (Shenouda I), the 55th Pope of Alexabdria",
        },
      ],
    },
    {
      day: "10",
      celebrations: [
        {
          title: "Departure of St. Isaac, disciple of St. Apollo.",
        },
        {
          title: "Departure of St. Gabriel II, the 70th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "11",
      celebrations: [
        {
          title: "Departure of St. Theodora the nun",
        },
        {
          title: "Departure of St. John, Bishop of Gaza",
        },
      ],
    },
    {
      day: "12",
      celebrations: [
        {
          title: "Commemoration of Michael, the Archangel",
        },
        {
          title: "Commemoration of St. Antonios, Bishop of Tamoui",
        },
        {
          title: "Departure of St. Alexander, Bishop of Jerusalem.",
        },
      ],
    },
    {
      day: "13",
      celebrations: [
        {
          title:
            "Martyrdom of the St. Joshua & St. Joseph, disciples of St. Melius",
        },
        {
          title:
            "Commemoration of St. Dionisa (Denisa) the Deaconess and St. Medius the Martyr",
        },
        {
          title: "Departure of St. John VII, the 77th Pope of Alexandria.",
        },
        {
          title: "Departure of St. John XVII, the 105th Pope of Alexandria.",
        },
        {
          title: "Martyrdom of the St. Midius",
        },
      ],
    },
    {
      day: "14",
      celebrations: [
        {
          title: "Departure of St. Maximus, the 15th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "15",
      celebrations: [
        {
          title:
            "Consecration of the first altar for St. Nicholas, Bishop of Myra for the Jacobite Christians",
        },
        {
          title: "Consecration of the church of St. Agabus the Apostle",
        },
        {
          title: "Departure of St. Alexandra the Empress",
        },
        {
          title: "Departure of St. Mark VI, the 101st Pope of Alexandria",
        },
      ],
    },
    {
      day: "16",
      celebrations: [
        {
          title: "Martyrdom of St. Antipas, Bishop of Pergamon",
        },
      ],
    },
    {
      day: "17",
      celebrations: [
        {
          title:
            "Martyrdom of St. James the Apostle, brother of St. John the Apostle",
        },
      ],
    },
    {
      day: "18",
      celebrations: [
        {
          title: "Martyrdom of St. Arsenius, Slave of St. Sousnyous",
        },
      ],
    },
    {
      day: "19",
      celebrations: [
        {
          title:
            "Martyrdom of St. Simeon the Armenian, Bishop of Persia and 150 with him",
        },
        {
          title: "Martyrdom of the St. Youhanna (John) Abu Nagaah El-Kabeer",
        },
        {
          title:
            "Martyrdom of the St. Vizier Abu Elaala Fahd ibn Ibrahim and his companions",
        },
        {
          title: "Martyrdom of St. Daoud, the Monk",
        },
      ],
    },
    {
      day: "20",
      celebrations: [
        {
          title: "Martyrdom of St. Babnuda of Dandara",
        },
      ],
    },
    {
      day: "21",
      celebrations: [
        {
          title:
            "Commemoration of the Holy Virgin St. Mary, the Mother of God (Theotokos)",
        },
        {
          title: "Departure of St. Hierotheos of Athens",
        },
      ],
    },
    {
      day: "22",
      celebrations: [
        {
          title: "Departure of St. Isaac of Hourin",
        },
        {
          title: "Departure of St. Alexander I, the 19th Pope of Alexandria",
        },
        {
          title: "Departure of St. Mark II, the 49th Pope of Alexandria",
        },
        {
          title: "Departure of St. Michael II, the 53rd Pope of Alexandria",
        },
      ],
    },
    {
      day: "23",
      celebrations: [
        {
          title: "Martyrdom of St. George, Prince of the Martyrs",
        },
      ],
    },
    {
      day: "24",
      celebrations: [
        {
          title:
            "Departure of St. Sinuthius (Shenouda I), the 55th Pope of Alexabdria",
        },
        {
          title: "Martyrdom of St. Sina, the Soldier",
        },
      ],
    },
    {
      day: "25",
      celebrations: [
        {
          title: "Martyrdom of St. Sarah of Antioch and her two Sons",
        },
        {
          title:
            "Commemoration of Sts. Babnuda (Paphnute) the Hermit, Theodore the Worshipper, and the One hundred Martyrs",
        },
      ],
    },
    {
      day: "26",
      celebrations: [
        {
          title: "Martyrdom of St. Sousenyos",
        },
        {
          title: "Departure of St. John VII, the 78th Pope of Alexandria",
        },
      ],
    },
    {
      day: "27",
      celebrations: [
        {
          title: "Martyrdom of St. Boctor, Son of Romanus",
        },
      ],
    },
    {
      day: "28",
      celebrations: [
        {
          title: "Martyrdom of St. Milius, the Ascetic",
        },
        {
          title: "Departure of St. Helena, the Empress",
        },
      ],
    },
    {
      day: "29",
      celebrations: [
        {
          title: "Departure of St. Erastus, the Apostle",
        },
        {
          title: "Departure of St. Acacius, Bishop of Jerusalem",
        },
      ],
    },
    {
      day: "30",
      celebrations: [
        {
          title:
            "Martyrdom of St. Mark, the Apostle & Evangelist of the Land of Egypt",
        },
      ],
    },
  ],
  Pashons: [
    {
      day: "01",
      celebrations: [
        {
          title:
            "Nativity of the Holy Virgin St. Mary, the Mother of God (Theotokos).",
        },
      ],
    },
    {
      day: "02",
      celebrations: [
        {
          title: "Departure of the Righteous Job. ",
        },
        {
          title: "Departure of St. Theodore the disciple of St. Pachomius.",
        },
        {
          title: "Martyrdom of St. Philotheos.",
        },
        {
          title: "Enthronement of St. Cyril VI, the 116th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "03",
      celebrations: [
        {
          title: "Departure of St. Jason, one of the Seventy disciples",
        },
        {
          title: "Martyrdom of St. Otimus, the Priest.",
        },
        {
          title: "Departure of St. Gabriel IV, the 86th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "04",
      celebrations: [
        {
          title: "Departure of St. John I, the 29th Pope of Alexandria.",
        },
        {
          title: "Departure of St. John V, the 72nd Pope of Alexandria",
        },
      ],
    },
    {
      day: "05",
      celebrations: [
        {
          title: "Martyrdom of Jeremiah, the Prophet.",
        },
      ],
    },
    {
      day: "06",
      celebrations: [
        {
          title: "Martyrdom of St. Isaac of Dafra.",
        },
        {
          title: "Departure of St. Macarius of Alexandria.",
        },
        {
          title: "Departure of St. Paphnute of El-Bandarah",
        },
      ],
    },
    {
      day: "07",
      celebrations: [
        {
          title:
            "Departure of St. Athanasius the Apostolic, the 20th Pope of Alexandria",
        },
        {
          title: "Nativity of St. Shenoute",
        },
      ],
    },
    {
      day: "08",
      celebrations: [
        {
          title: "Ascension of the Lord to heaven",
        },
        {
          title: "Martyrdom of St. John of Senhout.",
        },
        {
          title: "Departure of St. Daniel the Archpriest of Scetes",
        },
        {
          title: "Departure of Fr. Menassa Youhanna.",
        },
      ],
    },
    {
      day: "09",
      celebrations: [
        {
          title: "Departure of St. Helena, the Empress",
        },
        {
          title: "Departure of St. John XI, the 89th Pope of Alexandria",
        },
        {
          title: "Departure of St. Gabriel VIII, the 97th Pope of Alexandria",
        },
      ],
    },
    {
      day: "10",
      celebrations: [
        {
          title:
            "Departure of the Three Young Men in the furnace: Hananiah, Azariah, & Mishael.",
        },
      ],
    },
    {
      day: "11",
      celebrations: [
        {
          title: "Martyrdom of St. Theoclia, wife of St. Justus.",
        },
        {
          title: "Departure of St. Paphnutius, the Bishop.",
        },
        {
          title: "St. Nichomius",
        },
      ],
    },
    {
      day: "12",
      celebrations: [
        {
          title: "Appearance of a Cross of Light above Golgotha in 351",
        },
        {
          title: "Commemoration of Michael, the Archangel.",
        },
        {
          title:
            "Relocation of the relics of St. John Chrysostom from Comana to Constantinople",
        },
        {
          title: "Consecration of the Church of St. Demiana",
        },
        {
          title: "Departure of St. Mark VII, the 106th Pope of Alexandria.",
        },
        {
          title: "Martyrdom of Master Malati.",
        },
      ],
    },
    {
      day: "13",
      celebrations: [
        {
          title:
            "Departure of St. Arsenius, tutor of Arcadius & Honorius, the sons of Emperor Theodosius the Great.",
        },
      ],
    },
    {
      day: "14",
      celebrations: [
        {
          title: "Departure of St. Pachomius, Father of Cenobitic Monasticism.",
        },
        {
          title: "Martyrdom of St. Epimachus of Pelusium.",
        },
      ],
    },
    {
      day: "15",
      celebrations: [
        {
          title: "Martyrdom of St. Simon the Zealot.",
        },
        {
          title: "Martyrdom of the 400 saints in Dendera",
        },
        {
          title: "Commemoration of St. Mina the Deacon",
        },
        {
          title: "Sidrach",
        },
      ],
    },
    {
      day: "16",
      celebrations: [
        {
          title: "Commemoration of St. John the Evangelist.",
        },
      ],
    },
    {
      day: "17",
      celebrations: [
        {
          title: "Departure of St. Epiphanius, Bishop of Cyprus.",
        },
      ],
    },
    {
      day: "18",
      celebrations: [
        {
          title: "Commemoration of the Feast of Pentecost",
        },
        {
          title:
            "Departure of St. George (Ga'orgi), friend of St. Abraam of Scetes",
        },
        {
          title: "Consecration of the Church of St. Paul at Alexandria",
        },
        {
          title: "Commemoration of St. Shenoute",
        },
        {
          title:
            "Martyrdom of men, women, and children on Route to the Monastery of St. Samuel",
        },
      ],
    },
    {
      day: "19",
      celebrations: [
        {
          title: "Departure of St. Isaac al-Qulali",
        },
        {
          title: "Martyrdom of St. Isidorus of Antioch",
        },
      ],
    },
    {
      day: "20",
      celebrations: [
        {
          title: "Departure of St. Ammonius, the Hermit.",
        },
      ],
    },
    {
      day: "21",
      celebrations: [
        {
          title: "Holy Virgin St. Mary, the Mother of God (Theotokos).",
        },
        {
          title: "Departure of St. Martinianus of Caesarea",
        },
      ],
    },
    {
      day: "22",
      celebrations: [
        {
          title: "Departure of St. Andronicus, one of the Seventy disciples.",
        },
      ],
    },
    {
      day: "23",
      celebrations: [
        {
          title: "Departure of St. Junia, one of the Seventy disciples.",
        },
        {
          title: "Martyrdom of St. Julianus (Yulianus) and his Mother",
        },
      ],
    },
    {
      day: "24",
      celebrations: [
        {
          title: "Entry of the Lord Christ to Egypt.",
        },
        {
          title: "Departure of Habakkuk, the Prophet",
        },
        {
          title: "Martyrdom of the Monk St. Bashnouna.",
        },
      ],
    },
    {
      day: "25",
      celebrations: [
        {
          title: "Martyrdom of St. Colluthus of Antinoë",
        },
        {
          title: "Martyrdom of St. Hirutas",
        },
        {
          title: "Departure of Ibrahim El-Gohary.",
        },
      ],
    },
    {
      day: "26",
      celebrations: [
        {
          title: "Martyrdom of St. Thomas the Apostle.",
        },
      ],
    },
    {
      day: "27",
      celebrations: [
        {
          title: "Departure of St. John II, the 30th Pope of Alexandria.",
        },
        {
          title: "Departure of Lazarus the beloved of the Lord.",
        },
      ],
    },
    {
      day: "28",
      celebrations: [
        {
          title:
            "Relocation of the relics of St. Epiphanius, Bishop of Cyprus.",
        },
      ],
    },
    {
      day: "29",
      celebrations: [
        {
          title: "Departure of St. Simeon the Stylite.",
        },
      ],
    },
    {
      day: "30",
      celebrations: [
        {
          title: "Departure of St. Fortunatus, one of the Seventy disciples.",
        },
        {
          title: "Departure of St. Michael IV, the 68th Pope of Alexandria.",
        },
        {
          title: "St. Dumadius & St. Simon the Little",
        },
      ],
    },
  ],
  Paone: [
    {
      day: "01",
      celebrations: [
        {
          title: "Martyrdom of St. Cosmas of Taha and his companions",
        },
        {
          title: "Martyrdom of St. Zikam",
        },
        {
          title: " Consecration of the church of St. Leontius the Syrian.",
        },
        {
          title:
            "Consecration of the church of St. Phoebammon (Abu-Fam) the soldier",
        },
        {
          title: "Departure of Fr. Matta El Meskeen.",
        },
      ],
    },
    {
      day: "02",
      celebrations: [
        {
          title:
            "Appearance of the Bodies of St. John the Baptist and Elisha, the Prophet. ",
        },
        {
          title: "Departure of St. John XVIII, the 107th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "03",
      celebrations: [
        {
          title:
            "Consecration of the First Church of St. George in the cities of Birma, Egypt and Beer Maa, Egypt",
        },
        {
          title: "Martyrdom of St. Alladius the Bishop",
        },
        {
          title: "Departure of St. Martha of Egypt",
        },
        {
          title: "Departure of St. Cosmas I, the 44th Pope of Alexandria.",
        },
        {
          title: "Departure of St. Abraam, Bishop of Fayoum.",
        },
      ],
    },
    {
      day: "04",
      celebrations: [
        {
          title: "Martyrdom of St. Synesius (Sanusi) of Balqim",
        },
        {
          title: "Martyrdom of St. Amoun & St. Sophia the Righteous",
        },
        {
          title: "Martyrdom of St. John of Heraclea",
        },
        {
          title: "Departure of St. Hor",
        },
        {
          title: "Departure of St. John VIII, the 80th Pope of Alexandria",
        },
      ],
    },
    {
      day: "05",
      celebrations: [
        {
          title: "Departure of St. James the Oriental",
        },
        {
          title: "Martyrdom of St. Pshay & St. Peter",
        },
        {
          title: "Consecration of the Church of St. Victor in Shu",
        },
      ],
    },
    {
      day: "06",
      celebrations: [
        {
          title: "Martyrdom of St. Theodore the Monk of Alexandria",
        },
      ],
    },
    {
      day: "07",
      celebrations: [
        {
          title: "Martyrdom of St. Abaskhiron the Soldier",
        },
      ],
    },
    {
      day: "08",
      celebrations: [
        {
          title:
            "Commemoration of the Consecration of the Church of the Holy Virgin Mary in Musturud",
        },
        {
          title:
            "Martyrdom of St. Amadah and her sons, and St. Armanius and his mother St. Amah",
        },
        {
          title: "Martyrdom of St. George the New Martyr",
        },
      ],
    },
    {
      day: "09",
      celebrations: [
        {
          title: "Departure of Samuel, the Prophet.",
        },
        {
          title: "Martyrdom of St. Lucilianus, and four others with him",
        },
        {
          title: "Relocation of the Relics of St. Mercurius to Cairo, Egypt.",
        },
      ],
    },
    {
      day: "10",
      celebrations: [
        {
          title: "Martyrdom of St. Eudaemon, St. Epistemon, & St. Sophia",
        },
        {
          title:
            "Commemoration of the closing of the pagan temples and the opening of the Christian Churches by St. Constantine the Great .",
        },
        {
          title: "Departure of St. John XVI, the 103rd Pope of Alexandria.",
        },
        {
          title:
            "Enthronement of St. Demetrius II, the 111th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "11",
      celebrations: [
        {
          title:
            "Martyrdom of St. Claudius, son of Ptolemy and nephew of Numerian the Emperor",
        },
        {
          title:
            "Consecration of the Altar of the Forty Martyrs of Sebaste at the Savior's Church in Alexandria.",
        },
      ],
    },
    {
      day: "12",
      celebrations: [
        {
          title: "Commemoration of Michael, the Archangel.",
        },
        {
          title: "Departure of St. Justus, the 6th Pope of Alexandria.",
        },
        {
          title: "Departure of St. Cyril II, the 67th Pope of Alexandria.",
        },
        {
          title: "Departure of St. Euphemia the Widow",
        },
      ],
    },
    {
      day: "13",
      celebrations: [
        {
          title:
            "Commemoration of the Gabriel the Archangel, the Announcer of Daniel the Prophet.",
        },
        {
          title: "Departure of St. John II, Bishop of Jerusalem",
        },
      ],
    },
    {
      day: "14",
      celebrations: [
        {
          title: "Martyrdom of Sts. Cyrus, John, Ptolemaeus and Philip",
        },
        {
          title: "Departure of St. John XIX, the 113th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "15",
      celebrations: [
        {
          title:
            "The Turning Over of the Relics of the St. Mark the Apostle by the hand of Pope Paul VI, Pope of Rome.",
        },
        {
          title: "Consecration of the Church of St. Menas at Maryut",
        },
      ],
    },
    {
      day: "16",
      celebrations: [
        {
          title: "Departure of St. Onuphrius the Anchorite.",
        },
        {
          title: "Commemoration of St. Latson the Anchorite",
        },
      ],
    },
    {
      day: "17",
      celebrations: [
        {
          title: "Departure of St. Latsoun El-Bahnasa",
        },
        {
          title: "Return of the Relics of the St. Mark to St. Mark Cathedral",
        },
      ],
    },
    {
      day: "18",
      celebrations: [
        {
          title: "Departure of St. Damian, the 35th Pope of Alexandria.",
        },
        {
          title:
            "Inauguration of St. Mark Cathedral in the Monastery of Anba Rowais",
        },
      ],
    },
    {
      day: "19",
      celebrations: [
        {
          title: "Departure of St. Archillas, the 18th Pope of Alexandria",
        },
        {
          title: "Martyrdom of St. George el-Mozahem.",
        },
        {
          title: "Martyrdom of St. Bishai and St. Anoub",
        },
        {
          title:
            "First Pontifical Liturgy in St. Mark Cathedral in the Monastery of Anba Rowais.",
        },
      ],
    },
    {
      day: "20",
      celebrations: [
        {
          title: "Departure of Elisha, the Prophet.",
        },
      ],
    },
    {
      day: "21",
      celebrations: [
        {
          title:
            "Commemoration of the First Church for The Virgin Mary in the city of Caesarea Philippi",
        },
        {
          title: "Martyrdom of St. Timothy the Egyptian of Memphis",
        },
        {
          title: "Departure of St. Kadronos, 4th Pope of Alexandria",
        },
      ],
    },
    {
      day: "22",
      celebrations: [
        {
          title:
            "Consecration of the Church of Sts. Cosmas, Damian, Their Mother, and Brothers",
        },
      ],
    },
    {
      day: "23",
      celebrations: [
        {
          title: "Departure of St. Abba Noub, the Confessor",
        },
      ],
    },
    {
      day: "24",
      celebrations: [
        {
          title: "Martyrdom of St. Moses the Black",
        },
      ],
    },
    {
      day: "25",
      celebrations: [
        {
          title: "Martyrdom of St. Jude, one of the Seventy Disciples",
        },
        {
          title: "Departure of St. Peter IV, the 34th Pope of Alexandria",
        },
      ],
    },
    {
      day: "26",
      celebrations: [
        {
          title: "Departure of the Joshua the Prophet, Son of Nun",
        },
        {
          title: "Consecration of the Church of Gabriel, the Archangel",
        },
      ],
    },
    {
      day: "27",
      celebrations: [
        {
          title: "Martyrdom of St. Ananias, the Apostle.",
        },
        {
          title: "Martyrdom of St. Thomas of Shentalet",
        },
      ],
    },
    {
      day: "28",
      celebrations: [
        {
          title: "Departure of St. Theodosius, the 33rd Pope of Alexandria",
        },
        {
          title:
            "Commemoration of the Consecration of the Church of St. Sarabamoun, Bishop of Nikiu",
        },
      ],
    },
    {
      day: "29",
      celebrations: [
        {
          title: "Martyrdom of the Seven Ascetic Saints in Tounar Mount",
        },
        {
          title: "Martyrdom of Sts. Abba Hour and his Mother Theodora",
        },
        {
          title: "Consecration of the Church of Suriel. the Archangel",
        },
      ],
    },
    {
      day: "30",
      celebrations: [
        {
          title: "Nativity of St. John the Baptist",
        },
      ],
    },
  ],
  Epep: [
    {
      day: "01",
      celebrations: [
        {
          title: "Martyrdom of St. Febronia the Ascetic.",
        },
        {
          title:
            "Departure of St. Bioukha and St. Tayaban (Banayen) the Priest.",
        },
      ],
    },
    {
      day: "02",
      celebrations: [
        {
          title: "Departure of St. Thaddaeus, the Apostle. ",
        },
        {
          title: "Martyrdom of St. Benufa and St. Benaben",
        },
      ],
    },
    {
      day: "03",
      celebrations: [
        {
          title: "Departure of St. Cyril, the 24th Pope of Alexandria.",
        },
        {
          title: "Departure of St. Celestine, Bishop of Rome.",
        },
      ],
    },
    {
      day: "04",
      celebrations: [
        {
          title:
            "Commemoration of the Relocation of the Relics of Sts. Apakir and John.",
        },
      ],
    },
    {
      day: "05",
      celebrations: [
        {
          title: "Martyrdom of Sts. Peter and Paul, the Apostles.",
        },
      ],
    },
    {
      day: "06",
      celebrations: [
        {
          title: "Martyrdom of St. Aoulimpas, the Apostle.",
        },
        {
          title: "Martyrdom of St. Theodosia and her companions.",
        },
        {
          title: "St. Bartholomew of Rashid",
        },
      ],
    },
    {
      day: "07",
      celebrations: [
        {
          title: "Departure of St. Shenouda, the Archimandrite.",
        },
        {
          title: "Martyrdom of St. Ignatius, Bishop of Antioch.",
        },
      ],
    },
    {
      day: "08",
      celebrations: [
        {
          title: "Departure of St. Bishoy.",
        },
        {
          title: "Martyrdom of St. Piroou and St. Athom.",
        },
        {
          title: "Martyrdom of St. Balanah, the Priest.",
        },
        {
          title: "Martyrdom of St. Epime (Pimanon).",
        },
        {
          title:
            "Departure of St. Cyrus (Karas), brother of Emperor Theodosius.",
        },
        {
          title: "St. Marcus of the Monastery of St. Anthony",
        },
      ],
    },
    {
      day: "09",
      celebrations: [
        {
          title: "Martyrdom of St. Simon Cleophas, the Apostle.",
        },
        {
          title: "Departure of St. Cladianus, the 9th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "10",
      celebrations: [
        {
          title: "Martyrdom of St. Theodore, Bishop of Pentapolis.",
        },
        {
          title:
            "Martyrdom of St. Theodore, Bishop of Corinth, and his companion",
        },
        {
          title: "Departure of St. Gabriel VII, the 95th Pope of Alexandria.",
        },
        {
          title: "Commemoration of St. Olaghi the Anchorite",
        },
      ],
    },
    {
      day: "11",
      celebrations: [
        {
          title: "Martyrdom of Saints John and Simon, his cousin.",
        },
        {
          title: "Departure of St. Isaiah, the hermit.",
        },
      ],
    },
    {
      day: "12",
      celebrations: [
        {
          title: "Commemoration of Michael, the Archangel.",
        },
        {
          title: "Martyrdom of St. Hor of Siriakousy (Syracaus).",
        },
      ],
    },
    {
      day: "13",
      celebrations: [
        {
          title: "Departure of St. Pisentius, Bishop of Qift.",
        },
        {
          title: "Martyrdom of St. Abāmūn of Tukh.",
        },
        {
          title: "Martyrdom of St. Shenoute, during the early Arab Rule.",
        },
      ],
    },
    {
      day: "14",
      celebrations: [
        {
          title: "Martyrdom of St. Procopius (Proconius) of Jerusalem.",
        },
        {
          title: "Departure of St. Peter V, the 83rd Pope of Alexandria.",
        },
      ],
    },
    {
      day: "15",
      celebrations: [
        {
          title: "Departure of St. Ephrem the Syrian.",
        },
        {
          title: "Martyrdom of St. Cyriacus and St. Julietta, his Mother.",
        },
        {
          title: "Martyrdom of St. Horesius (Harsios) of Soul.",
        },
      ],
    },
    {
      day: "16",
      celebrations: [
        {
          title: "Departure of St. John, of the Golden Gospel..",
        },
        {
          title:
            "Recovery of the Holy Relics of St. George, the Prince of the Martyrs.",
        },
        {
          title: "Consecration of the Church of St. Philotheus",
        },
        {
          title: "St. Isidore of Heliopolis",
        },
      ],
    },
    {
      day: "17",
      celebrations: [
        {
          title: "Martyrdom of St. Euphemia.",
        },
      ],
    },
    {
      day: "18",
      celebrations: [
        {
          title: "Martyrdom of St. James the Apostle, Bishop of Jerusalem.",
        },
      ],
    },
    {
      day: "19",
      celebrations: [
        {
          title:
            "Martyrdom of St. Bidaba, Bishop of Qift, St. Andrew, and St. Christodoulas",
        },
        {
          title: "Martyrdom of St. Pantaleemon, the Physician.",
        },
        {
          title: "Departure of St. John X, the 85th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "20",
      celebrations: [
        {
          title: "Martyrdom of St. Theodore of Shotep.",
        },
      ],
    },
    {
      day: "21",
      celebrations: [
        {
          title:
            "Commemoration of the Holy Virgin Saint Mary, the Mother of God (Theotokos",
        },
        {
          title: "Departure of St. Sisinnios (Sosenius), the Eunich.",
        },
      ],
    },
    {
      day: "22",
      celebrations: [
        {
          title:
            "Martyrdom of St. Macarius, the Son of Basilides (Wasilides) the Minister.",
        },
        {
          title: "Martyrdom of St. Leontius (Lawendius) of Tripoli.",
        },
      ],
    },
    {
      day: "23",
      celebrations: [
        {
          title: "Martyrdom of St. Longinus, the Soldier.",
        },
        {
          title: "Martyrdom of St. Marina, of Antioch.",
        },
      ],
    },
    {
      day: "24",
      celebrations: [
        {
          title: "Ascension of Enoch",
        },
        {
          title: "Martyrdom of St. Abanoub.",
        },
        {
          title: "Departure of St. Simeon I, the 42nd Pope of Alexandria.",
        },
      ],
    },
    {
      day: "25",
      celebrations: [
        {
          title: "Departure of St. Thecla.",
        },
        {
          title: "Martyrdom of St. Isaac of Shama.",
        },
        {
          title: "Martyrdom of St. Hilaria of Damira.",
        },
        {
          title: "Martyrdom of Sts. Thecla and Mouji.",
        },
        {
          title: "Martyrdom of St. Anthony of Beba.",
        },
        {
          title: "Martyrdom of St. Abakragoun.",
        },
        {
          title: "Martyrdom of St. Domadius El-Souriani (The Syrian).",
        },
        {
          title: "Consecration of the Church of St. Mercurius",
        },
        {
          title: "Departure of St. Palamon, the Father of the Monks.",
        },
      ],
    },
    {
      day: "26",
      celebrations: [
        {
          title: "Departure of the Upright St. Joseph, the Carpenter",
        },
        {
          title: "Departure of St. Timothy I, the 22nd Pope of Alexandria.",
        },
      ],
    },
    {
      day: "27",
      celebrations: [
        {
          title: "Consecration of the Church of St. Fam the Soldier.",
        },
        {
          title: "Martyrdom of St. Abāmūn of Tarnūt.",
        },
      ],
    },
    {
      day: "28",
      celebrations: [
        {
          title: "Departure of St. Mary Magdalene.",
        },
        {
          title: "Commemoration of St. Simon the Tanner.",
        },
      ],
    },
    {
      day: "29",
      celebrations: [
        {
          title:
            "Commemoration of the Holy Gospel, the Nativity, and the Resurrection of Christ",
        },
        {
          title:
            "Commemoration of the Translocation of the Relics of St. Andrew, the Apostle",
        },
        {
          title: "Martyrdom of St. Quarshenoufa (Warshenofius).",
        },
      ],
    },
    {
      day: "30",
      celebrations: [
        {
          title: "Martyrdom of Sts. Mercurius and Ephraem.",
        },
      ],
    },
  ],
  Mesore: [
    {
      day: "01",
      celebrations: [
        {
          title: "Martyrdom of St. Apoli, Son of Justus.",
        },
        {
          title: "Departure of St. Cyril V, the 112th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "02",
      celebrations: [
        {
          title: " Departure of St. Pa'esa (Athanasia) of Minuf",
        },
        {
          title: "Martyrdom of St. Menas",
        },
      ],
    },
    {
      day: "03",
      celebrations: [
        {
          title:
            "Relocation of the Body of St. Simeon the Stylite to the city of Antioch.",
        },
        {
          title:
            "Departure of St. Abriamus (Primus), the 5th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "04",
      celebrations: [
        {
          title: "Departure of Hezekiah the King.",
        },
        {
          title: "Consecration of the Church of St. Anthony the Great.",
        },
      ],
    },
    {
      day: "05",
      celebrations: [
        {
          title: "Departure of St. John the Soldier.",
        },
      ],
    },
    {
      day: "06",
      celebrations: [
        {
          title: "Martyrdom of St. Julietta.",
        },
        {
          title: "St. Besa, disciple of St. Shenute",
        },
      ],
    },
    {
      day: "07",
      celebrations: [
        {
          title:
            "Annunciation of St. Joachim with the Birth of the Virgin Mary.",
        },
        {
          title: "Departure of St. Timothy II, the 26th Pope of Alexandria.",
        },
        {
          title: "Commemoration of St. Pasantaos the Anchorite",
        },
      ],
    },
    {
      day: "08",
      celebrations: [
        {
          title:
            "Martyrdom of the Sts. Lazarus, Salomi, His Wife and their Children.",
        },
        {
          title:
            "Confession of St. Peter, the Apostle, that Christ is the Son of the Living God.",
        },
      ],
    },
    {
      day: "09",
      celebrations: [
        {
          title: "Martyrdom of St. Ari, the Priest of Shatanouf.",
        },
      ],
    },
    {
      day: "10",
      celebrations: [
        {
          title: "Martyrdom of St. Matra.",
        },
        {
          title: "Martyrdom of St. Pigebs (Bekhebs).",
        },
        {
          title: "Martyrdom of St. Yuhannis",
        },
      ],
    },
    {
      day: "11",
      celebrations: [
        {
          title: "Departure of St. Moisis, Bishop of Ouseem.",
        },
      ],
    },
    {
      day: "12",
      celebrations: [
        {
          title: "Commemoration of Michael, the Archangel.",
        },
        {
          title:
            "Enthronement of the Righteous Emperor Constantine, the Great.",
        },
      ],
    },
    {
      day: "13",
      celebrations: [
        {
          title: "Feast of Transfiguration of Our Lord on Mount Tabor.",
        },
      ],
    },
    {
      day: "14",
      celebrations: [
        {
          title:
            "Commemoration of the great miracle, the Lord had manifested during the papacy of St. Theophilus, the 23rd Pope of Alexandria.",
        },
      ],
    },
    {
      day: "15",
      celebrations: [
        {
          title: "Departure of St. Mary known as Marina, the Ascetic",
        },
        {
          title: "Departure of St. Habib Girgis.",
        },
      ],
    },
    {
      day: "16",
      celebrations: [
        {
          title: "Assumption of the Body of the Pure Virgin St. Mary.",
        },
        {
          title: "Departure of St. Matthew IV, the 102nd Pope of Alexandria.",
        },
      ],
    },
    {
      day: "17",
      celebrations: [
        {
          title: "Martyrdom of St. James, the Soldier.",
        },
      ],
    },
    {
      day: "18",
      celebrations: [
        {
          title: "Departure of St. Alexander, Patriarch of Constantinople.",
        },
        {
          title: "Martyrdom of St. Eudaemon, of Armant.",
        },
      ],
    },
    {
      day: "19",
      celebrations: [
        {
          title:
            "Translocation of the Body of St. Macarius to His Monastery in Scetis.",
        },
      ],
    },
    {
      day: "20",
      celebrations: [
        {
          title: "Martyrdom of the Seven Young Men of Ephesus.",
        },
        {
          title: "",
        },
      ],
    },
    {
      day: "21",
      celebrations: [
        {
          title:
            "Commemoration of the Holy Virgin Saint Mary, the Mother of God (Theotokos).",
        },
        {
          title: "Departure of St. Irene (Eirene).",
        },
      ],
    },
    {
      day: "22",
      celebrations: [
        {
          title: "Departure of Micah, the Prophet.",
        },
        {
          title: "Martyrdom of St. Hadid of Giza.",
        },
        {
          title: "Concentration of the Church of St. Mohrael.",
        },
      ],
    },
    {
      day: "23",
      celebrations: [
        {
          title: "Martyrdom of thirty thousand Christians in Alexandria.",
        },
        {
          title: "Martyrdom of St. Damian in Antioch.",
        },
      ],
    },
    {
      day: "24",
      celebrations: [
        {
          title: "Departure of St. Takla Haymanot, the Ethiopian.",
        },
        {
          title: "Departure of St. Thomas, Bishop of Marash.",
        },
      ],
    },
    {
      day: "25",
      celebrations: [
        {
          title: "Departure of St. Bessarion, disciple of St. Anthony",
        },
        {
          title: "Departure of St. Macarius III, the 114th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "26",
      celebrations: [
        {
          title: "Martyrdom of St. Moses and his Sister Sarah.",
        },
        {
          title:
            "Martyrdom of St. Agabius, the Soldier, and his Sister Thecla.",
        },
      ],
    },
    {
      day: "27",
      celebrations: [
        {
          title: "Martyrdom of Sts. Benjamin and his sister Eudexia.",
        },
        {
          title: "Martyrdom of St. Mary, the Armenian.",
        },
      ],
    },
    {
      day: "28",
      celebrations: [
        {
          title: "Commemoration of the Patriarchs: Abraham, Isaac, and Jacob.",
        },
      ],
    },
    {
      day: "29",
      celebrations: [
        {
          title:
            "Martyrdom of Saints Athanasius, the Bishop, Gerasimus (Jarasimus), and Theodotus",
        },
        {
          title:
            "Arrival of the Holy Relic of St. John the Short, to the Wilderness of Scetis.",
        },
      ],
    },
    {
      day: "30",
      celebrations: [
        {
          title: "Departure of Malachi, the Prophet.",
        },
      ],
    },
  ],
  PiKogiEnavot: [
    {
      day: "01",
      celebrations: [
        {
          title: "Departure of St. Eutychus.",
        },
        {
          title: "Martyrdom of St. Pishay (Abshai), the Antiochian",
        },
      ],
    },
    {
      day: "02",
      celebrations: [
        {
          title: "Departure of St. Titus, the Apostle.",
        },
        {
          title: "Martyrdom of St. Isaiah, brother of Apa Hor",
        },
      ],
    },
    {
      day: "03",
      celebrations: [
        {
          title: "Commemoration of Raphael, the Archangel.",
        },
        {
          title: "Martyrdom of St. Andrianus.",
        },
        {
          title: "Departure of St. John XIV, the 96th Pope of Alexandria",
        },
      ],
    },
    {
      day: "04",
      celebrations: [
        {
          title: "Departure of St. Liberius, Bishop of Rome.",
        },
        {
          title: "Departure of St. Poimen, the Hermit.",
        },
        {
          title: "St. Inianamon",
        },
      ],
    },
    {
      day: "05",
      celebrations: [
        {
          title: "Departure of St. James, Bishop of Cairo.",
        },
        {
          title: "Departure of Amos, the Prophet.",
        },
        {
          title: "Departure of St. Parsoma, the 'Naked'",
        },
        {
          title: "Departure of St. John XV, the 99th Pope of Alexandria.",
        },
      ],
    },
    {
      day: "06",
      celebrations: [
        {
          title: "Thanksgiving to God the Exalted.",
        },
      ],
    },
  ],
};
